/* unplugin-vue-components disabled */import script from "./my-footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./my-footer.vue?vue&type=script&setup=true&lang=ts"

import "./my-footer.vue?vue&type=style&index=0&id=ad5b088e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad5b088e"]])

export default __exports__